export const defaultTitle = process.env.REACT_APP_SITE_TITLE || "";
export const envPrefix =
  process.env.REACT_APP_ENVIRONMENT !== "PRD" ? `**${process.env.REACT_APP_ENVIRONMENT}** - ` : "";

export const createPageTitle = (page: string) => `${envPrefix}Claims - Home - General - ${page}`;
